const getters = {
  inWX: state => state.app.inWX,
  isPC: state => state.app.isPC,
  isIos: state => state.app.isIos,
  isAndroid: state => state.app.isAndroid
}

export default getters
